// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1p8qA","popup":"Modal_popup__1-j7e","popover":"Modal_popover__1gksc"};